import React from 'react'
import { Link } from 'react-router-dom';

import PageHeading from '../../../components/common/PageHeading'
import RightBar from '../../../components/common/RightBar'
import Footer from '../../../components/common/Footer';
import RightBarMethod from '../../../components/common/RightBar/RightBarMethod';

import './ScreeningCriteria.css';

import { templates } from '../../../data/templates';
import { Col, Popover, Row, Table } from 'antd';
import { IoMdHelpCircle } from 'react-icons/io';
import { FaQuestionCircle } from 'react-icons/fa';


const popoverContent = () => {
    return(
        <p className='common-paragraph para'>
            We have introduced Screening Policies for better control over how you use Screening. Go to the <a href='/' className='onclick-tex'>Go to policy page</a> to assign criteria templates and properties to your policies.
        </p>
    );
};

function PopOver(){

    return(
        <span className="plain-text silver-text">
            Assign Properties to Templates{" "}
            <Popover trigger="click" content={popoverContent} title="Application Fees">
                <FaQuestionCircle size={12} className="circled-question" />  
            </Popover> {" "}
        </span>
    );
}


const ScreeningCriteriaRightBar = [
    RightBarMethod("Tasks", "t1",<i className="fa-solid fa-star"></i>, [
        RightBarMethod("Assign Criteria to Policies", "1", "", "", "/generalsettings/screening-criteria/assign-criteria-to-policies"),
        RightBarMethod(<PopOver />, "2", "", "", "/generalsettings/screening-criteria/assign-properties-templates"),
      ]),
      RightBarMethod("HELP TOPICS", "t2",<IoMdHelpCircle />, [
        RightBarMethod("Screening Criteria", "3", "", "", "/generalsettings/screening-criteria/screening-criteria"),
        RightBarMethod("Screening Policies", "4", "", "", "/generalsettings/screening-criteria/screening-policies"),
        RightBarMethod("Review Screening Result", "5", "", "", "/generalsettings/screening-criteria/review-screening-result"),
        RightBarMethod("Override a Preliminary Result", "6", "", "", "/generalsettings/screening-criteria/override-preliminary-result"),
      ]),
];

function ScreeningCriteria() {

    const columns = [
        {
            title: "Template Name",
            dataIndex: "templateName",
            key: "templateName",
            render: (text, record) => <Link to={`/generalsettings/screening-criteria/${record.id}`}>{text}</Link>
        }
    ];
  return (
    <>
        <div className='page-container'>
        <div className="main-container">
            <PageHeading heading="Screening Criteria Templates" />
            <Row>
                <Col span={24} className="table-container">
                    <Table columns={columns} dataSource={templates} pagination={false} />
                </Col>
            </Row>
            <Footer />
        </div>
        </div>
        <div className="RightSidebar">
            <RightBar RightBarData={ScreeningCriteriaRightBar} />
        </div>
    </>
  )
}

export default ScreeningCriteria;